"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.error.title': 'Aktywacja nie powiodła się',
    'activate.error.generic': 'Wystąpił błąd podczas aktywacji konta',
    'activate.error.no_token': 'Nie podano tokenu aktywacyjnego',
    'activate.error.network': 'Wystąpił błąd sieci',
    'activate.error.invalid_link': 'Nieprawidłowy link aktywacyjny',
    'activate.error.invalid_link_description': 'Link aktywacyjny, na który kliknąłeś, jest nieprawidłowy lub wygasł. Spróbuj zarejestrować się ponownie lub skontaktuj się z obsługą.',
};
